// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chip-module__root--V7RYf {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline: 10px;
  border: 1px solid var(--chip-border-color);
  border-radius: 999px;
  background: var(--chip-background);
  color: var(--chip-color);
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
}

.Chip-module__variant-default--BGfX8 {
  --chip-background: transparent;
  --chip-border-color: transparent;
}

.Chip-module__variant-subtle--f2MTm {
  --chip-background: var(--chaek-color-surface-subtle);
  --chip-border-color: var(--chaek-color-surface-subtle);
  --chip-color: var(--chaek-color-text-filter-inactive);
}

.Chip-module__variant-ghost--vPmfT {
  --chip-background: var(--chaek-color-surface-subtle);
  --chip-border-color: var(--chaek-color-border-divider);
  --chip-color: var(--chaek-color-text-primary);
}

.Chip-module__variant-soft--jH7du {
  --chip-background: var(--chaek-color-surface-subtle);
  --chip-border-color: var(--chaek-color-surface-subtle);
  --chip-color: #ff8d28;
}

.Chip-module__variant-primary--_vmqk {
  --chip-background: var(--chaek-color-surface-inverse);
  --chip-border-color: var(--chaek-color-surface-inverse);
  --chip-color: var(--chaek-color-text-inverse);
}

.Chip-module__is-disabled--BQsHn {
  --chip-background: var(--chaek-color-surface-subtle);
  --chip-border-color: var(--chaek-color-surface-subtle);
  --chip-color: var(--chaek-color-text-filter-inactive);
}

.Chip-module__is-selected--oChdz {
  --chip-background: #f1e9de;
  --chip-border-color: #1a1a1a;
  --chip-color: #1a1a1a;
}

.Chip-module__size-small--tfV9d {
  --chip-label-padding-bottom: 0;

  height: 25px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 0.6875rem; /* 11px */
  font-weight: 400;
  letter-spacing: 0.0645px;
}

.Chip-module__size-medium--d471i {
  --chip-label-padding-bottom: 0;

  height: 34px;
  padding-inline: 16px;
  border-radius: 20px;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
}

.Chip-module__size-large--eeBk1 {
  --chip-label-padding-bottom: 0;

  height: 44px;
  padding-right: 10px;
  padding-left: 14px;
  border-radius: 999px;
  font-size: 0.8125rem; /* 13px */
  font-weight: 400;
  line-height: 18px;
}

.Chip-module__label--X1EB_ {
  padding-bottom: var(--chip-label-padding-bottom, 1px);
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Chip/Chip.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;EACpD,sDAAsD;EACtD,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;EACpD,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;EACpD,sDAAsD;EACtD,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,uDAAuD;EACvD,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;EACpD,sDAAsD;EACtD,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;;EAE9B,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;;EAE9B,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;;EAE9B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;AACvD","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-inline: 10px;\n  border: 1px solid var(--chip-border-color);\n  border-radius: 999px;\n  background: var(--chip-background);\n  color: var(--chip-color);\n  font-weight: 600;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.variant-default {\n  --chip-background: transparent;\n  --chip-border-color: transparent;\n}\n\n.variant-subtle {\n  --chip-background: var(--chaek-color-surface-subtle);\n  --chip-border-color: var(--chaek-color-surface-subtle);\n  --chip-color: var(--chaek-color-text-filter-inactive);\n}\n\n.variant-ghost {\n  --chip-background: var(--chaek-color-surface-subtle);\n  --chip-border-color: var(--chaek-color-border-divider);\n  --chip-color: var(--chaek-color-text-primary);\n}\n\n.variant-soft {\n  --chip-background: var(--chaek-color-surface-subtle);\n  --chip-border-color: var(--chaek-color-surface-subtle);\n  --chip-color: #ff8d28;\n}\n\n.variant-primary {\n  --chip-background: var(--chaek-color-surface-inverse);\n  --chip-border-color: var(--chaek-color-surface-inverse);\n  --chip-color: var(--chaek-color-text-inverse);\n}\n\n.is-disabled {\n  --chip-background: var(--chaek-color-surface-subtle);\n  --chip-border-color: var(--chaek-color-surface-subtle);\n  --chip-color: var(--chaek-color-text-filter-inactive);\n}\n\n.is-selected {\n  --chip-background: #f1e9de;\n  --chip-border-color: #1a1a1a;\n  --chip-color: #1a1a1a;\n}\n\n.size-small {\n  --chip-label-padding-bottom: 0;\n\n  height: 25px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 0.6875rem; /* 11px */\n  font-weight: 400;\n  letter-spacing: 0.0645px;\n}\n\n.size-medium {\n  --chip-label-padding-bottom: 0;\n\n  height: 34px;\n  padding-inline: 16px;\n  border-radius: 20px;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n}\n\n.size-large {\n  --chip-label-padding-bottom: 0;\n\n  height: 44px;\n  padding-right: 10px;\n  padding-left: 14px;\n  border-radius: 999px;\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.label {\n  padding-bottom: var(--chip-label-padding-bottom, 1px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Chip-module__root--V7RYf`,
	"variant-default": `Chip-module__variant-default--BGfX8`,
	"variant-subtle": `Chip-module__variant-subtle--f2MTm`,
	"variant-ghost": `Chip-module__variant-ghost--vPmfT`,
	"variant-soft": `Chip-module__variant-soft--jH7du`,
	"variant-primary": `Chip-module__variant-primary--_vmqk`,
	"is-disabled": `Chip-module__is-disabled--BQsHn`,
	"is-selected": `Chip-module__is-selected--oChdz`,
	"size-small": `Chip-module__size-small--tfV9d`,
	"size-medium": `Chip-module__size-medium--d471i`,
	"size-large": `Chip-module__size-large--eeBk1`,
	"label": `Chip-module__label--X1EB_`
};
export default ___CSS_LOADER_EXPORT___;
